module.exports = __webpack_public_path__ + "static/media/arrowRight.f60eaf34.png";